import React from 'react'
import Link from 'next/link'
import Trans from 'next-translate/Trans'
import { useTranslation } from 'hooks/useTranslation'
import {
  NeverAgainRoot,
  Flex,
  Content,
  ButtonWrapper,
  Header,
  Description,
  CopyContainer,
} from './NeverAgain.styles'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'

type NeverAgainProps = {}

export const NeverAgain: React.FC<NeverAgainProps> = ({}) => {
  const { t } = useTranslation()

  return (
    <NeverAgainRoot id="never-again">
      <Flex>
        <Content>
          <Stack direction="column" gap={{"@initial": "4", "@bp2": "5"}}>
            <CopyContainer direction="column" gap={{"@initial": "2", "@bp2": "3"}}>
              <Header>
                <Trans
                  i18nKey="raw-food-subscription:never-again.title"
                  components={{ br: <br /> }}
                />
              </Header>
              <Description size="body" as="p">
                {t('raw-food-subscription:never-again.description')}
              </Description>
            </CopyContainer>

            <ButtonWrapper>
              <Link href="/meal-plan" passHref>
                <Button className='cta'>{t('raw-food-subscription:cta')}</Button>
              </Link>
            </ButtonWrapper>
          </Stack>
        </Content>
      </Flex>
    </NeverAgainRoot>
  )
}
